import { useSyncExternalStore } from 'react';

import { type CatalogSearchOrigin } from '~/features/catalog/hooks/use-track-catalog-search-completed';

import { URL_SEARCH_ORIGIN } from '../constants';

type CatalogSearchDraftListener = () => void;

let catalogSearchDraft = '';
let catalogSearchOrigin: CatalogSearchOrigin = URL_SEARCH_ORIGIN;
const listeners = new Set<CatalogSearchDraftListener>();

function emitCatalogSearchDraft() {
  listeners.forEach((listener) => listener());
}

export function getCatalogSearchDraft() {
  return catalogSearchDraft;
}

export function getCatalogSearchOrigin() {
  return catalogSearchOrigin;
}

export function setCatalogSearchDraft(value: string, origin?: CatalogSearchOrigin) {
  const nextOrigin = origin ?? catalogSearchOrigin;
  if (catalogSearchDraft === value && catalogSearchOrigin === nextOrigin) {
    return;
  }

  catalogSearchDraft = value;
  catalogSearchOrigin = nextOrigin;
  emitCatalogSearchDraft();
}

export function subscribeCatalogSearchDraft(listener: CatalogSearchDraftListener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useCatalogSearchDraft() {
  return useSyncExternalStore(subscribeCatalogSearchDraft, getCatalogSearchDraft, getCatalogSearchDraft);
}

export function useCatalogSearchOrigin() {
  return useSyncExternalStore(subscribeCatalogSearchDraft, getCatalogSearchOrigin, getCatalogSearchOrigin);
}
